import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

export interface ComingSoonBadgeProps {
  className?: string
}

/**
 * A small overlay badge indicating a feature is coming soon.
 * Designed to be positioned as a superscript indicator on buttons or labels.
 * Requires parent element to have relative positioning.
 */
export const ComingSoonBadge = ({ className }: ComingSoonBadgeProps): ReactNode => (
  <Badge
    variant="outline"
    className={cn(
      'coming-soon-badge absolute -top-1 -right-2 px-1 py-0 text-[10px] leading-tight',
      'bg-amber-100 text-amber-700 border-amber-300',
      'dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-700',
      className
    )}
  >
    Soon
  </Badge>
)

ComingSoonBadge.displayName = 'ComingSoonBadge'
